/**
 * Created by Carsten Hibbeler on 07.01.2016.
 * Copyright: xdot GmbH 2015
 */

import { AppContext } from '../app-context';
import { apiName } from '../utils/api-util';
import ActionTypesCommon from '../constants/ActionTypesCommon';

import warning from '../utils/warning';

function requestData(data) {
    try { //new style is to use api for api and method
        let { api, apiMethod } = data, s = api && api.split('.');
        if (s && s.length > 1) {
            api = s[ 0 ];
            apiMethod = s[ 1 ];
        }
        const apiFktn = AppContext.getWebApis()[ api ] && AppContext.getWebApis()[ api ][ apiMethod ];

        if (typeof apiFktn !== 'function') {
            console.error(apiFktn + ` apiFktn: ${api}/${apiMethod} not found! ` +
                JSON.stringify(AppContext.getWebApis(), null, 3) +
                ' \n More: ' + JSON.stringify(data, null, 3));
            return;
        }

        //we call the api with the query a parameter
        const callApiWithQuery = data => apiFktn(data.query, data);

        AppContext.getDispatcher().dispatchAsyncOperation(ActionTypesCommon.DATA_ASYNC, callApiWithQuery, data, {
            meta: {
                className: data.className,
                name: data.name
            }
        });
    } catch (e) {
        console.error('requestData', data, e);
    }

}


export function activeStores() {
    const stores = AppContext.getStores();
    return Object.keys(stores).filter(key => !stores[ key ].isActive || stores[ key ].isActive()).map(key => stores[ key ]);
}

let isRefreshingRemoteData = false;

export default {


    refreshRemoteData() {

        if (!isRefreshingRemoteData) {
            try {
                isRefreshingRemoteData = true;
                const invalidLists = [];
                activeStores().forEach(store => store.getRequiredRemoteDataUpdates && invalidLists.push(...store.getRequiredRemoteDataUpdates()));
                if (invalidLists.length > 0) {
                    try {
                        console.groupCollapsed('Request RemoteData:', invalidLists);
                        invalidLists.forEach(requestData);
                    } finally {
                        console.groupEnd();
                    }

                }
            } catch (e) {
                console.error(e);
            } finally {
                isRefreshingRemoteData = false;
            }
        }

    },


    /**
     * payload should look like {className: 'abc', id: 4711}
     *
     * We use a very generic method because in the future we possibly want to do something like:
     * payload: [
     *  {className: 'abc', id: 4711},
     *  {className: 'abc', id: 99},
     *  {className: 'efg', id: 1234}
     * ]
     */
    pageSelected(className, query, api) {
        this.dispatchRemoteDataAction(ActionTypesCommon.PAGE_SELECTED, null, className, query, apiName(api));
    },

    attachedList(name, className, api, byId, byClassName, query = null) {
        return this.list(name, className, {
            ...query,
            byId,
            byClassName
        }, apiName(api));
    },

    attachedItem(name, className, api, byId, byClassName, query = null) {
        return this.item(name, className, {
            ...query,
            byId,
            byClassName
        }, apiName(api));
    },

    //if api and apiMethod are null the default action for class is used
    list(name, className, query, api = null) {
        warning(query, 'todo is empty list init a good idea?');
        this.dispatchRemoteDataAction(ActionTypesCommon.DATA_LIST_INIT, name, className, query, apiName(api));
    },

    item(name, className, query, api = null) {
        warning(query, 'todo is empty item init a good idea?');
        this.dispatchRemoteDataAction(ActionTypesCommon.DATA_ITEM_INIT, name, className, query, apiName(api));
    },

    moreItems(name, className, query) {
        this.dispatchRemoteDataAction(ActionTypesCommon.MORE_ITEMS, name, className, query);
    },

    invalidate(name, className) {
        this.dispatchRemoteDataAction(ActionTypesCommon.DATA_INVALIDATE, name, className);
    },

    remove(name, className) {
        if (Array.isArray(name)) {
            name.forEach(n => this.remove(n, className));
        } else {
            this.dispatchRemoteDataAction(ActionTypesCommon.DATA_REMOVE, name, className);
        }
    },

    /**
     * Optimistic inits are supported by passing for Items: {item: {...}} or for Lists: {item: [...], query: {}}.
     * Optimistic inits are intialized as invalid!
     *
     * @param type action type
     * @param name target list name optional
     * @param className target className
     * @param querOrData
     *      1. query like {id: 3} or {foo: 'bar'}
     *      2. existing remote data
     *      3. optimistic inits for Items {item: {id:23, ...}}
     *      4. optimistic inits for Lists {item: [], query: {...}}
     * @param api for an api different the default list and get
     */
    dispatchRemoteDataAction(type, name, className, querOrData /*query or data*/, api = null) {
        let payload;

        if (querOrData && querOrData.item) {
            payload = { ...querOrData };
        } else {
            if (querOrData) {
                warning(Object.keys(querOrData).length <= 6, 'query seems to be raw item object!');
            }
            else if (type !== ActionTypesCommon.DATA_INVALIDATE && type !== ActionTypesCommon.DATA_REMOVE){
                console.warn('QueryOrData emtpy', querOrData);
            }

            payload = querOrData ? { query: querOrData } : {};

        }

        api = apiName(api);

        if (payload.api || api) {
            payload.api = api || payload.api;
        }

        AppContext.getDispatcher().dispatch({
            type,
            payload,
            meta: {
                className,
                name
            }
        });
    }

};






// WEBPACK FOOTER //
// ./js/actions/RemoteDataActions.js